/* eslint-disable */
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function GetPendingEvaluations() { // เปลี่ยนชื่อจาก AllDepartment ให้สื่อความหมาย
  const { data, setData } = useDataContext();
  const [cookies] = useCookies(['session']);
  const [name, setName] = useState(null);

  // ตัวกันยิงซ้ำ
  const hasFetched = useRef(false);

  // 1. แปลง Token (ใช้ useMemo เพื่อไม่ให้ decode ซ้ำทุก render)
  const decodedToken = useMemo(() => {
    try {
      return cookies?.session ? jwtDecode(cookies.session) : null;
    } catch (e) { return null; }
  }, [cookies?.session]);

  // 2. Logic หา User ปัจจุบัน
  useEffect(() => {
    if (decodedToken && data?.getAllEmployees) {
      const foundEmployee = data.getAllEmployees.find(
        (employee) => 
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
      );
      setName(foundEmployee);
    }
  }, [decodedToken, data?.getAllEmployees]);

  // 3. Fetch Logic
  useEffect(() => {
    // เงื่อนไขการหยุด:
    // 1. ยังไม่มีข้อมูลพนักงาน (name.employeeId)
    // 2. มีข้อมูลใน Context อยู่แล้ว (data.getPendingEvaluations) -> Cache Hit
    // 3. เคยยิงไปแล้ว (hasFetched) -> Strict Mode Protection
    
    if (!name?.employeeId) return;
    if (data.getPendingEvaluations && data.getPendingEvaluations.length > 0) return;
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        const response = await fetch(
          `${API_URL}/getEvaluationAssignmentsByEmployeeId/${name.employeeId}`,
          requestOptions
        );
        const result = await response.json();

        setData((prevData) => ({
          ...prevData,
          getPendingEvaluations: result.data || [],
        }));
      } catch (error) {
        console.error('Error fetching pending evaluations:', error);
        hasFetched.current = false; // Reset on error
      }
    };

    fetchData();

  }, [name]); // รันเมื่อ user (name) เปลี่ยนเท่านั้น

  return null;
}

export default GetPendingEvaluations;